import React from 'react';
import MyMessage from './MyMessage';
import { useTitle } from '../../hooks/useTitle';

const MypageMessage = () => {
  useTitle('Ton Bébé | メッセージ');

  return (
    <main className="sub">
      <MyMessage />
    </main>
  );
}

export default MypageMessage;
